export default __webpack_public_path__ + "static/media/888.f2f3a274.gif";